import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { MobileArticle } from '@wdx/portal/api-models';
import { StateStatus } from '../state.model';
import { ArticlesActions, ListingType } from './articles.actions';
import {
    ERROR_STATUS,
    INITIAL_STATUS,
    LOADING_STATUS,
    SUCCESS_STATUS,
} from '../state.constants';

export interface ListingState extends StateStatus, EntityState<MobileArticle> {}

export const ARTICLES_DATA_FEATURE_KEY = 'articles';

export interface ArticlesState {
    [ListingType.Recommended]: ListingState;
    [ListingType.Distributed]: ListingState;
    article: ListingState;
}

export const adapter: EntityAdapter<MobileArticle> =
    createEntityAdapter<MobileArticle>();

const { selectAll } = adapter.getSelectors();

export const selectAllTeam = selectAll;

export const initialState: ArticlesState = {
    [ListingType.Recommended]: {
        ...adapter.getInitialState({
            ...INITIAL_STATUS,
        }),
    },
    [ListingType.Distributed]: {
        ...adapter.getInitialState({
            ...INITIAL_STATUS,
        }),
    },
    article: adapter.getInitialState({
        ...INITIAL_STATUS,
    }),
};

export const articlesReducer = createReducer(
    initialState,

    on(ArticlesActions.getDistributedArticles, (state) => ({
        ...state,
        [ListingType.Distributed]: {
            ...state[ListingType.Distributed],
            ...LOADING_STATUS,
        },
    })),
    on(
        ArticlesActions.getDistributedArticlesSuccess,
        (state, { articles }) => ({
            ...state,
            [ListingType.Distributed]: adapter.upsertMany(articles, {
                ...state[ListingType.Distributed],
                ...SUCCESS_STATUS,
            }),
        }),
    ),
    on(ArticlesActions.getDistributedArticlesFailure, (state) => ({
        ...state,
        [ListingType.Distributed]: adapter.removeAll({
            ...state[ListingType.Distributed],
            ...ERROR_STATUS,
        }),
    })),

    on(ArticlesActions.getRecommendedArticles, (state) => ({
        ...state,
        [ListingType.Recommended]: {
            ...state[ListingType.Recommended],
            ...LOADING_STATUS,
        },
    })),
    on(
        ArticlesActions.getRecommendedArticlesSuccess,
        (state, { articles }) => ({
            ...state,
            [ListingType.Recommended]: adapter.upsertMany(articles, {
                ...state[ListingType.Recommended],
                ...SUCCESS_STATUS,
            }),
        }),
    ),
    on(ArticlesActions.getRecommendedArticlesFailure, (state) => ({
        ...state,
        [ListingType.Recommended]: adapter.removeAll({
            ...state[ListingType.Recommended],
            ...ERROR_STATUS,
        }),
    })),

    on(ArticlesActions.getArticle, (state, props) => ({
        ...state,
        article: {
            ...state.article,
            ...LOADING_STATUS,
        },
    })),
    on(ArticlesActions.getArticleSuccess, (state, { article }) => ({
        ...state,
        article: adapter.upsertOne(article, {
            ...state.article,
            ...SUCCESS_STATUS,
        }),
    })),
    on(ArticlesActions.getArticleFailure, (state) => ({
        ...state,
        article: {
            ...state.article,
            ...ERROR_STATUS,
        },
    })),
);
